import SectionHeroCustom from './SectionHeroCustom';
export default SectionHeroCustom;
